export const incidence = {
  external: 'external',
  internal: 'internal',
}
